import React from "react";

import cn from "classnames";
import Icon from "../../../../components/Icon";
import styles from "./SettingsCard.module.sass";
const SettingsCard = ({
  icon,
  title,
  description,
  fill,
  className = "",
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-start p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer",
        styles.cardcontainer
      )}
    >
      <div className={cn(styles.icondiv)}>
        <div className={cn(styles.iconcontainer)}>
          <Icon name={icon} size="38" fill={fill} />
        </div>
      </div>

      <div style={{ width: "95%" }}>
        <div className={cn(styles.cardtitle)}> {title}</div>

        <div className={cn(styles.description)} style={{ width: "86%" }}>
          {description}{" "}
        </div>
      </div>
    </div>
  );
};

export default SettingsCard;
